<template>
  <div
    :class="[
      layoutTypeClass,
      navbarClasses,
      footerClasses,
      {'no-scroll': isAppPage},
      'layout--main'
    ]"
  >
    <v-nav-menu
      v-if="isPro"
      :nav-menu-items="navMenuItems"
      title="Kolesa PRO"
      parent=".layout--main"
    />
    <vs-popup
      :active="calendarModal.isShow"
      title="Скачать аналитический отчёт"
      @close="toggleCalendarModal"
    >
      <calendar
        :position="calendarModal.position"
        :option="calendarModal.viewsOption"
        is-from-report
        class="calendar mb-8"
        @init="onDateReceive"
        @change="onDateReceive"
      />
      <div class="calendar__button-wrap">
        <vs-button
          :disabled="isDownloadDisabled || isLoading"
          class="calendar__submit"
          @click="print"
        >
          <LoaderSpinner
            v-if="isLoading"
            class-name="calendar__loader"
            change-color="true"
          />
          <span v-else>Скачать отчет</span>
        </vs-button>
        <div
          v-if="isDownloadDisabled"
          class="calendar__info"
        >
          <span class="calendar__icon fi-info-service-unfilled" />
          <span class="calendar__tip">Минимальный период отчёта – неделя</span>
        </div>
      </div>
    </vs-popup>
    <iframe
      v-if="isFrameVisible"
      ref="frame"
      :src="src"
      class="frame"
    />
    <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">
      <div id="content-overlay" />

      <!-- Navbar -->
      <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1148">
        <header-horizontal
          :navbar-type="navbarType"
          :class="[
            {'text-white' : isNavbarDark && !isThemeDark},
            {'text-base' : !isNavbarDark && isThemeDark}
          ]"
        />

        <h-nav-menu
          v-if="isPro"
          :class="[
            {'text-white' : isNavbarDark && !isThemeDark},
            {'text-base' : !isNavbarDark && isThemeDark}
          ]"
          :nav-menu-items="navMenuItems"
          @openModal="toggleCalendarModal"
        />
      </template>

      <template v-else-if="isAuthorized">
        <header-vertical
          :class="[
            {'text-white' : isNavbarDark && !isThemeDark},
            {'text-base' : !isNavbarDark && isThemeDark}
          ]"
          :navbar-color="navbarColor"
          :is-show-menu="isPro"
        />
      </template>
      <!-- /Navbar -->

      <div class="content-wrapper">
        <div class="router-view">
          <div class="router-content">
            <div class="content-area__content">
              <transition :name="routerTransition" mode="out-in">
                <router-view
                  @changeRouteTitle="changeRouteTitle"
                  @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)"
                />
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade-top">
      <audio-player-modal v-if="isShowAudioPlayer" />
    </transition>
    <transition name="fade">
      <div v-if="isShowTutorial" class="tutorial__overlay" />
    </transition>
    <help-popup
      v-if="isPro"
      :is-show="helpPopupState.isShow"
      :refill-complex="helpPopupState.refillComplex"
      @toggle="$store.commit('help/POPUP_TOGGLE', false)"
    />
  </div>
</template>

<script>
import { mapGetters }   from 'vuex';
import dayjs from 'dayjs';
import { checkRole }    from '@/constants';
import { themeConfig }  from '@/../themeConfig.js';
import HNavMenu         from '@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue';
import navMenuItems     from '@/layouts/components/vertical-nav-menu/navMenuItems.js';
import HeaderHorizontal from '@/layouts/components/header/HeaderHorizontal.vue';
import HeaderVertical   from '@/layouts/components/header/HeaderVertical.vue';
import VNavMenu         from '@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue';
import AudioPlayerModal from '@/components/AudioPlayerModal.vue';
import HelpPopup        from '@/components/HelpPopup';
import Calendar         from '@/components/calendar/Template';
import LoaderSpinner    from '@/components/LoaderSpinner';
import { DEFAULT_TIMEOUT, MIN_DAYS_NB } from '@/views/pages/report/config';

export default {
  components: {
    LoaderSpinner,
    Calendar,
    AudioPlayerModal,
    HNavMenu,
    HeaderHorizontal,
    HeaderVertical,
    VNavMenu,
    HelpPopup,
  },
  data() {
    return {
      footerType:       themeConfig.footerType || 'static',
      hideScrollToTop:  themeConfig.hideScrollToTop,
      isNavbarDark:     false,
      navbarColor:      themeConfig.navbarColor || '#fff',
      navbarType:       themeConfig.navbarType || 'floating',
      navMenuItems,
      routerTransition: themeConfig.routerTransition || 'none',
      routeTitle:       this.$route.meta.pageTitle,
      isFrameLoaded:    false,
      date:             [],
      isFrameVisible:   false,
      isLoading:        false,
      calendarModal:    {
        isShow:   false,
        isViews:  false,
        position: {
          position: 'inherit',
        },
        leadsOption: 0,
        leadsLabel:  'Последние 30 дней',
        viewsOption: 0,
        viewsLabel:  'Последние 30 дней',
      },
    };
  },
  computed: {
    ...mapGetters({
      isShowAudioPlayer: 'audioPlayer/isShow',
      isShowTutorial:    'getTutorialOverlayState',
      userInfo:          'userInfo',
      isAuthorized:      'isAuthorized',
      isPro:             'isPro',
      helpPopupState:    'help/getPopupState',
    }),
    bodyOverlay() { return this.$store.state.bodyOverlay; },
    contentAreaClass() {
      if (this.mainLayoutType === 'vertical') {
        if (this.verticalNavMenuWidth === 'default') return 'content-area-reduced';
        if (this.verticalNavMenuWidth === 'reduced') return 'content-area-lg';
        return 'content-area-full';
      }
      // else if(this.mainLayoutType === "boxed") return "content-area-reduced"
      return 'content-area-full';
    },
    footerClasses() {
      return {
        'footer-hidden': this.footerType === 'hidden',
        'footer-sticky': this.footerType === 'sticky',
        'footer-static': this.footerType === 'static',
      };
    },
    isAppPage() {
      return this.$route.meta.no_scroll;
    },
    isThemeDark() { return this.$store.state.theme === 'dark'; },
    layoutTypeClass() { return `main-${this.mainLayoutType}`; },
    mainLayoutType() { return this.$store.state.mainLayoutType; },
    navbarClasses() {
      return {
        'navbar-hidden':   this.navbarType === 'hidden',
        'navbar-sticky':   this.navbarType === 'sticky',
        'navbar-static':   this.navbarType === 'static',
        'navbar-floating': this.navbarType === 'floating',
      };
    },
    verticalNavMenuWidth() { return this.$store.state.verticalNavMenuWidth; },
    windowWidth() { return this.$store.state.windowWidth; },

    /**
     * URL отчета для iframe
     *
     * @return {string} - url отчета
     */
    src() {
      return `/report?startDate=${this.date[0]}&endDate=${this.date[1]}`;
    },

    /**
     * Отключена ли кнопка скачивания отчета?
     *
     * @return {boolean}
     */
    isDownloadDisabled() {
      const dateFrom = dayjs(this.date[0]);
      const dateTo = dayjs(this.date[1]);

      return dateTo.diff(dateFrom, 'day') < MIN_DAYS_NB;
    },
  },
  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
    },
    isThemeDark(val) {
      const color = this.navbarColor === '#fff' && val ? '#10163a' : '#fff';
      this.updateNavbarColor(color);
    },
    '$store.state.mainLayoutType': function (val) {
      this.setNavMenuVisibility(val);
    },
  },
  created() {
    const color = this.navbarColor === '#fff' && this.isThemeDark ? '#10163a' : this.navbarColor;
    this.updateNavbarColor(color);
    this.setNavMenuVisibility(this.$store.state.mainLayoutType);
  },
  methods: {
    /**
     * Генерирует PDF
     * Таймер требуется для подгрузки всех картинок в отчете
     *
     */
    async print() {
      this.isFrameVisible = true;
      this.isLoading = true;

      await this.$nextTick();

      if (!this.$refs.frame) return;

      let timeout;

      const onReady = () => {
        clearTimeout(timeout);
        this.$refs.frame.contentWindow.focus();
        this.$refs.frame.contentWindow.print();

        this.toggleCalendarModal();
        this.isLoading = false;
      };

      timeout = setTimeout(() => {
        this.$refs.frame.contentWindow.removeEventListener('message', onReady);
        this.isLoading = false;

        this.$vs.notify({
          title: 'Ошибка генерации отчета, повторите попытку или попробуйте позже',
          color: 'danger',
        });
      }, DEFAULT_TIMEOUT);

      this.$refs.frame.contentWindow.addEventListener('message', onReady);
    },

    /**
     * Получаем дату из календаря
     *
     * @param {Array} date
     * @param {number} option
     */
    onDateReceive(date, option) {
      this.date = date;
      this.calendarModal.viewsOption = option;
      this.isFrameLoaded = false;
    },

    /**
     * Открытие / Закрытие модалки календаря
     *
     * @param {boolean} bool
     */
    toggleCalendarModal() {
      this.isFrameVisible = false;
      this.calendarModal.isShow = !this.calendarModal.isShow;
    },

    changeRouteTitle(title) {
      this.routeTitle = title;
    },
    updateNavbarColor(val) {
      this.navbarColor = val;
      this.isNavbarDark = val !== '#fff';
    },
    setNavMenuVisibility(layoutType) {
      if ((layoutType === 'horizontal' && this.windowWidth >= 1148)
              || (layoutType === 'vertical' && this.windowWidth < 1148)) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false);
      }
    },
  },
};

</script>

<style lang="scss" scoped>
@import "@/assets/scss/vuexy/_variables.scss";

.calendar {
  &__button-wrap {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  &__submit {
    min-height: 40px;
    min-width: 128px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__icon {
    color: $blue-primary;
  }

  &__info {
    position: relative;
    right: -20px;
    width: 298px;
    font-size: 13px;
    line-height: 20px;
    display: flex;
    align-items: center;
    padding: 8px;
    justify-content: space-between;
    border-radius: 8px;
    background: $payed-yellow;
  }
}
</style>
